import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API,
});

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `${token}`,
    }
  };
};

export const getLandlord = async (data) => {
    const response = await api.get('/claim/landlord');
    return response.data;
  };

export const getProperty = async (data) => {
  const response = await api.get('/claim/property?landlordId=' + data.landlordId);
  return response.data;
};

export const getRider = async (data) => {
  const response = await api.get('/claim/rider?landlordId='+ data.landlordId);
  return response.data;
};

export const getClaimId = async (data) => {
  const response = await api.post('/claim/create', data);
  return response.data;
};

export const getContentVersion = async (data) => {
  const response = await api.post('/claim/content', data);
  return response.data
}

export const checkPolicyDuplicated = async (data) => {
  const response = await api.get('/claim/claim-duplicated?riderId=' + data);
  return response.data
}